import React from 'react';
import { Fragment, useEffect, useState } from 'react'
import CustomButton from '../customButton/CustomButton';
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';

interface IDialog {
  children: any;
  open: boolean;
  title: string;
  toggleDialog: () => void;
  size?: "small" | "medium" | "large" | "fullscreen"
  fullscreen?: boolean;
  yesNo?: boolean;
  hideButtons?: boolean;
  cancelAction?: () => void;
  approveAction?: () => void;
}

/**
 *
 * @param children TSXComponent - component to render in modal body
 * @param open boolean - toggles showing or hiding dialog
 * @param title string - title to display at top of dialog window
 * @param toggleDialog () => void - function tied to close button in top right corner
 * @param size string - large, medium, small, fullscreen. If no size is provided defaults to medium
 * @param yesNo boolean - changes buttons to Yes/No instead of Save/Cancel
 * @param hideButtons boolean - hides the dialog actions bar if your actions are handled in the children
 * @returns
 */
const CustomDialog = (props: IDialog) => {
  const { yesNo, children, title, open, toggleDialog, size, hideButtons, approveAction, cancelAction } = props

  const [height, setHeight] = useState<number>(0);
  const [width, setWidth] = useState<number>(0);

  useEffect(() => {
    switch (size) {
      case "fullscreen":
        setHeight(1000 < window.screen.height ? 1000 : window.screen.height);
        setWidth(1000 < window.screen.width ? 1000 : window.screen.width);
        break;
      case "large":
        setHeight(600 < window.screen.width ? 600 : window.screen.width);
        setWidth(850 < window.screen.width ? 850 : window.screen.width);
        break;
      case "medium":
        setHeight(500 < window.screen.height ? 500 : window.screen.height);
        setWidth(700 < window.screen.width ? 700 : window.screen.width);
        break;
      case "small":
        setHeight(350 < window.screen.height ? 350 : window.screen.height);
        setWidth(500 < window.screen.width ? 500 : window.screen.width);
        break;
      default:
        setHeight(500 < window.screen.height ? 500 : window.screen.height);
        setWidth(700 < window.screen.width ? 700 : window.screen.width);
        break;
    }
  }, [size])

  return (
    <Fragment>
      {
        open && height > 0 && width > 0 && 
        (
          <Window
            title={title}
            onClose={toggleDialog}
            resizable
            initialWidth={width}
            initialHeight={height}
            initialTop={(window.innerHeight / 2) - height / 2}
            initialLeft={(window.innerWidth / 2) - width / 2}
            modal
          >
            {children}
            {!hideButtons ? (
              <WindowActionsBar layout="end">
                <CustomButton onClick={approveAction ? approveAction : () => { }} icon={yesNo ? "check" : "save"}>
                  {yesNo ? "Yes" : "Save"}
                </CustomButton>
                <CustomButton onClick={cancelAction ? cancelAction : () => { }} themeColor="error" icon={yesNo ? "x" : "cancel"}>
                  {yesNo ? "No" : "Cancel"}
                </CustomButton>
              </WindowActionsBar>
            ) : null}
          </Window>
        )
      }
    </Fragment>
  )
}

export default CustomDialog